<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('investigation.title') }}</div>
                <div class="mainBody">
                    <div style="margin:0 auto; font-size:0.27rem;line-height:0.45rem;padding-bottom: .3rem;">
                        <div>
                            <p>{{ $t('investigation.user') }}<br>　　{{ $t('investigation.tips') }}
                            </p>
                        </div>
                        <br>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question1') }}</p>
                            <p>
                                <label for="q1_1"><input type="radio" value="満足" name="q1" v-model="q1" id="q1_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q1_2"><input type="radio" value="普通" name="q1" v-model="q1" id="q1_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q1_3"><input type="radio" value="不満足" name="q1" v-model="q1" id="q1_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question2') }}</p>
                            <p>
                                <label for="q2_1"><input type="radio" value="満足" name="q2" v-model="q2" id="q2_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q2_2"><input type="radio" value="普通" name="q2" v-model="q2" id="q2_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q2_3"><input type="radio" value="不満足" name="q2" v-model="q2" id="q2_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question3') }}</p>
                            <p>
                                <label for="q3_1"><input type="radio" value="満足" name="q3" v-model="q3" id="q3_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q3_2"><input type="radio" value="普通" name="q3" v-model="q3" id="q3_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q3_3"><input type="radio" value="不満足" name="q3" v-model="q3" id="q3_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question4') }}</p>
                            <p>
                                <label for="q4_1"><input type="radio" value="満足" name="q4" v-model="q4" id="q4_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q4_2"><input type="radio" value="普通" name="q4" v-model="q4" id="q4_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q4_3"><input type="radio" value="不満足" name="q4" v-model="q4" id="q4_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question5') }}</p>
                            <p>
                                <label for="q5_1"><input type="radio" value="満足" name="q5" v-model="q5" id="q5_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q5_2"><input type="radio" value="普通" name="q5" v-model="q5" id="q5_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q5_3"><input type="radio" value="不満足" name="q5" v-model="q5" id="q5_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question6') }}</p>
                            <p>
                                <label for="q6_1"><input type="radio" value="満足" name="q6" v-model="q6" id="q6_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q6_2"><input type="radio" value="普通" name="q6" v-model="q6" id="q6_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q6_3"><input type="radio" value="不満足" name="q6" v-model="q6" id="q6_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question7') }}</p>
                            <p>
                                <label for="q7_1"><input type="radio" value="満足" name="q7" v-model="q7" id="q7_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q7_2"><input type="radio" value="普通" name="q7" v-model="q7" id="q7_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q7_3"><input type="radio" value="不満足" name="q7" v-model="q7" id="q7_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question8') }}</p>
                            <p>
                                <label for="q8_1"><input type="radio" value="満足" name="q8" v-model="q8" id="q8_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q8_2"><input type="radio" value="普通" name="q8" v-model="q8" id="q8_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q8_3"><input type="radio" value="不満足" name="q8" v-model="q8" id="q8_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div :class="$i18n.locale == 'jp' ? 'question' : 'question'">
                            <p>{{ $t('investigation.question9') }}</p>
                            <p>
                                <label for="q9_1"><input type="radio" value="満足" name="q9" v-model="q9" id="q9_1" />{{
                                    $t('investigation.select1') }}</label>
                                <label for="q9_2"><input type="radio" value="普通" name="q9" v-model="q9" id="q9_2" />{{
                                    $t('investigation.select2') }}</label>
                                <label for="q9_3"><input type="radio" value="不満足" name="q9" v-model="q9" id="q9_3" />{{
                                    $t('investigation.select3') }}</label>
                            </p>
                        </div>
                        <div>
                            <p>{{ $t('investigation.question10') }}</p>
                            <p>
                                <textarea v-model="q10" rows="3"
                                                                    style="max-height:100px; width:100%; border:1px #CCC solid;" id="q10" name="q10"
                                                                    value=""></textarea>
                            </p>
                        </div>
                        <br>
                        <p>{{ $t('investigation.thanks') }}</p>
                        <br>
                        <div>
                            <p><input type="submit" :value="$t('investigation.btn')" id="submit" @click="submit" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            q1: "",
            q2: "",
            q3: "",
            q4: "",
            q5: "",
            q6: "",
            q7: "",
            q8: "",
            q9: "",
            q10: "",
            toastShow: false,
            toastText: ""
        }
    },
    created() {
        //_hmt.push(['_divackPageview', '/investigation']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.clear();
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        },
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
        submit() {
            let that = this, data = new FormData();
            if (that.q1 == "") {
                that.toast(this.$t('investigation.question1'))
            } else if (that.q2 == "") {
                that.toast(this.$t('investigation.question2'))
            } else if (that.q3 == "") {
                that.toast(this.$t('investigation.question3'))
            } /* else if (that.q4 == "") {
                that.toast(this.$t('investigation.question4'))
            } */ else if (that.q5 == "") {
                that.toast(this.$t('investigation.question5'))
            } else if (that.q6 == "") {
                that.toast(this.$t('investigation.question6'))
            } else if (that.q7 == "") {
                that.toast(this.$t('investigation.question7'))
            } else if (that.q8 == "") {
                that.toast(this.$t('investigation.question8'))
            } else if (that.q9 == "") {
                that.toast(this.$t('investigation.question9'))
            } /* else if (that.q10 == "") {
                that.toast(this.$t('investigation.question10'))
            } */ else {
                data.append('q1', that.q1);
                data.append('q2', that.q2);
                data.append('q3', that.q3);
                data.append('q4', that.q4);
                data.append('q5', that.q5);
                data.append('q6', that.q6);
                data.append('q7', that.q7);
                data.append('q8', that.q8);
                data.append('q9', that.q9);
                data.append('q10', that.q10);
                data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
                that.axios.post('https://questionnaire.event1.cn/QuestionnaireNissan/checkin', data).then(res => {
                    if (res.data.code == 200) {
                        that.toast(this.$t('back.success_text2'));
                        setTimeout(() => {
                            that.$router.replace("/menu")
                        }, 1000)
                    } else {
                        that.toast(this.$t('investigation.already'));
                        setTimeout(() => {
                            that.$router.replace("/menu")
                        }, 1000)
                    }
                }).catch(err => { })
            }
        }
    }
}
</script>
<style scoped>
.container {
    padding-bottom: .5rem;
}

input::-webkit-input-placeholder {
    color: #ccc;
}

input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ccc;
}

input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ccc;
}

input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #ccc;
}

input[type="text"] {
    -webkit-appearance: none !important;
}

textarea {
    -webkit-appearance: none !important;
}

input {
    -webkit-appearance: none !important;
}


input[type="button"],
input[type="submit"],
input[type="reset"] {
    -webkit-appearance: none !important;
}

input[type='radio'],
input[type='checkbox'] {
    width: .26rem;
    height: .26rem;
    appearance: none;
    -webkit-appearance: none;
    transform: translateZ(1px);
    border-radius: 0;
}

input[type='radio'],
input[type='checkbox'] {
    background: url('https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/radio_check.png') no-repeat;
    background-size: .26rem .26rem;
    transform: translateZ(0);
}

input[type='radio']:checked,
input[type='checkbox']:checked {
    background: url('https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/radio_checkd.png') no-repeat;
    background-size: .26rem .26rem;
    transform: translateZ(0);
}

textarea {
    -webkit-appearance: none;
}

#submit {
    padding: .2rem .5rem;
    width: 140px;
    text-align: center;
    background-color: #17aba2;
    color: #FFF;
    line-height: 13px;
    cursor: pointer;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    display: block;
    margin: 0 auto;
    font-size: .3rem;
}

.toast {
    padding: .2rem .6rem;
}

.question {
    padding-bottom: .4rem;
}

.question>p:last-child {
    padding-top: .1rem;
    display: flex;
    justify-content: space-between;
}

.question>p:last-child>label {
    padding-right: .3rem;
    display: flex;
    align-items: center;
    line-height: 1;
}

.question>p:last-child>label>input {
    margin-right: .1rem;
}

.question_en {
    padding-bottom: .3rem;
}

.question_en>p:last-child {
    padding-top: .1rem;
    display: flex;
    flex-direction: column;
}

.question_en>p:last-child>label {
    padding-right: .7rem;
    display: flex;
    align-items: center;
    line-height: .4rem;
}

.question_en>p:last-child>label>input {
    margin-right: .1rem;
}
</style>


// WEBPACK FOOTER //
// src/views/investigation.vue